import React from 'react';

import { TextInput, Button, MaterialIcon } from '../atoms';
import { Container } from "./Container";
import { ResetPasswordController } from "../controllers";

export default class ResetPassword extends Container {

    constructor(props) {
        super(props);

        this.state = {
            PASSWORD: "",
			CONFIRM_PASSWORD: "",
			ERROR: ""
		};
		
		

        this.controller = new ResetPasswordController(this.callback, this.getState, this.props.router);

        
    }

    render() {
        const { PASSWORD, CONFIRM_PASSWORD, ERROR } = this.state;
        return (
            <section className="login flex -h">
				<div className="informations flex -v -sa">
					<div>
						<h2>Bem Vindo!</h2>
						<p>A melhor avaliação Hídrica do Brasil</p>
					</div>
					<div className="descriptions">
						<div>- Mensuração</div>
						<div>- Gestão</div>
						<div>- Engajamento e Comunicação</div>
					</div>
					<span className="mail"><MaterialIcon type="email" color="white"/>  contato@h20company</span>
				</div>
				<form action={this.controller.submitAction} className="box">
					<img src="/assets/images/logo.png"></img>
					<label className="label-login">Resetar Senha</label>
					<TextInput
						id="PASSWORD"
						value={PASSWORD}
						type={"password"}
						changeAction={this.controller.changeAction}
						label="Nova senha:"
						error={ERROR}
					/>
					<TextInput
						type="password"
						id="CONFIRM_PASSWORD"
						value={CONFIRM_PASSWORD}
						changeAction={this.controller.changeAction}
						label="Confirmar nova senha:"
					/>
					<Button className="bcg-green" clickAction={this.controller.submitAction}>Enviar</Button>
				</form>
				<a style={{ position: "absolute", left: "99999999999999" }} className="waves-effect waves-light btn modal-trigger" href="#ie"></a>
			</section>
        );
    }
}


// WEBPACK FOOTER //
// src/containers/ResetPassword.js